<template>
    <div class="profile-page page safe-page">
        <AppHeader :title="t('profile.title')" :show-back="true" class=" h-80px!" />

        <div class="container">
            <div class="section">
                <div class="section-title">{{ t('profile.yourAvatar') }}</div>

                <div class="avatar-row  justify-center relative">
                    <div class="avatar-wrap ">
                        <div class="avatar-inner">
                            <img :src="form?.avatar || userInfo?.avatar" class="avatar-img" fill />

                        </div>
                        <img src="@/assets/images/mine/upload.webp" class="upload-img" />
                        <input class="upload-input" type="file" accept="image/*" @change="onUpload" />
                    </div>
                </div>
            </div>

            <div class="form">
                <div class="field">
                    <div class="label flex align-center">
                        {{ t('profile.yourName') }}<span class="req block" v-if="!isEditInfo"></span>
                        <span class="hint flex align-center mt-2px">{{ t('profile.whatCallMe') }}</span>
                    </div>
                    <div class="input">
                        <input v-model="form.nickname" :placeholder="t('profile.yourName')" @focus="handleInputFocus"
                            @blur="handleInputBlur" @input="handleNicknameInput" />
                        <span class="count">{{ getStringLength(form.nickname) }}/20</span>
                    </div>
                </div>

                <div class="grid-2">
                    <div class="field">
                        <div class="label">{{ t('profile.yourAge') }}</div>
                        <div class="input">
                            <van-field class="w-100%" maxlength="3" v-model="ageFieldValue" type="digit"
                                :formatter="onlyDigits" format-trigger="onChange" :placeholder="t('profile.yourAge')"
                                @focus="handleInputFocus" @blur="handleInputBlur" />
                        </div>
                    </div>
                    <div class="field" @click="showPicker = true">
                        <div class="label">{{ t('profile.race') }}</div>
                        <div class="input ">
                            <span class="sfx left-0! p-15px">{{ form.raceText || t('profile.pleaseSelect') }}</span>
                            <!-- <input v-model="form.raceText" disabled placeholder="Your Skin color" @click="showPicker = true" /> -->
                        </div>
                    </div>
                </div>

                <div class="grid-2">
                    <div class="field">
                        <div class="label">{{ t('profile.yourWeight') }}</div>
                        <div class="input suffix">
                            <span class="sfx">kg</span>

                            <van-field class="w-100%" v-model="weightFieldValue" type="digit" maxlength="3"
                                :formatter="onlyDigits" format-trigger="onChange" :placeholder="t('profile.yourWeight')"
                                @focus="handleInputFocus" @blur="handleInputBlur" />

                            <!-- <input v-model.number="form.userExtend.weight" type="number" placeholder="Your Weight" /> -->
                        </div>
                    </div>
                    <div class="field">
                        <div class="label">{{ t('profile.yourHeight') }}</div>
                        <div class="input suffix relative">
                            <span class="sfx absolute right-0 bottom-10px">cm</span>
                            <van-field class="w-100%" v-model="heightFieldValue" type="digit" maxlength="3"
                                :formatter="onlyDigits" format-trigger="onChange" :placeholder="t('profile.yourHeight')"
                                @focus="handleInputFocus" @blur="handleInputBlur" />

                            <!-- <input v-model.number="form.userExtend.height" type="number" placeholder="Your Height" /> -->
                        </div>
                    </div>
                </div>

                <div class="field">
                    <div class="label">{{ t('profile.gender') }}</div>
                    <div class="seg">
                        <button :class="['seg-btn', form.sex === 1 && 'active']" @click="form.sex = 1">{{ t('profile.male') }}</button>
                        <button :class="['seg-btn', form.sex === 2 && 'active']" @click="form.sex = 2">{{ t('profile.female') }}</button>
                        <button :class="['seg-btn', form.sex === 3 && 'active']" @click="form.sex = 3">{{ t('profile.neutral') }}</button>
                    </div>
                </div>

                <div class="field">
                    <div class="label">{{ t('profile.hobby') }}</div>
                    <div class="textarea">
                        <textarea v-model="form.userExtend.hobby" :placeholder="t('profile.pleaseEnter')"
                            @focus="handleInputFocus" @blur="handleInputBlur" @input="handleHobbyInput"></textarea>
                        <span class="count">{{ getStringLength(form.userExtend.hobby.trim()) }}/100</span>
                    </div>
                </div>

                <div class="field">
                    <div class="label">{{ t('profile.favoriteFood') }}</div>
                    <div class="textarea">
                        <textarea v-model="form.userExtend.favorite_food" :placeholder="t('profile.pleaseEnter')"
                            @focus="handleInputFocus" @blur="handleInputBlur"
                            @input="handleFavoriteFoodInput"></textarea>
                        <span class="count">{{ getStringLength(form.userExtend.favorite_food.trim()) }}/100</span>
                    </div>
                </div>

                <div class="field">
                    <div class="label">{{ t('profile.yourCharacter') }}</div>
                    <div class="textarea">
                        <textarea v-model="form.userExtend.character" :placeholder="t('profile.pleaseEnter')"
                            @focus="handleInputFocus" @blur="handleInputBlur" @input="handleCharacterInput"></textarea>
                        <span class="count">{{ getStringLength(form.userExtend.character.trim()) }}/100</span>
                    </div>
                </div>

                <div class="field">
                    <div class="label">{{ t('profile.fantasyAboutOtherHalf') }}</div>
                    <div class="textarea">
                        <textarea v-model="form.userExtend.desired_partner" :placeholder="t('profile.pleaseEnter')"
                            @focus="handleInputFocus" @blur="handleInputBlur"
                            @input="handleDesiredPartnerInput"></textarea>
                        <span class="count">{{ getStringLength(form.userExtend.desired_partner.trim()) }}/100</span>
                    </div>
                </div>
            </div>

            <div class="footer_btn fixed bottom-0px w-40%">
                <div class="save-btn" @click="onSave">{{ t('common.save') }}</div>
            </div>
        </div>
        <AppOccupySpace height="150px"></AppOccupySpace>
        <van-popup v-model:show="showPicker" destroy-on-close position="bottom">
            <van-picker :title="t('profile.race')" :columns="columns" :confirm-button-text="t('common.confirm')" :cancel-button-text="t('common.cancel')"
                @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>
    </div>

</template>

<script setup lang="ts">
import { reactive, computed, onMounted, ref } from 'vue'
import { AppHeader, AppOccupySpace } from '@/components/layout'
import theme from '@/styles/theme'
import { useUserStore } from '@/stores/user'
import { showToast, showLoadingToast, closeToast } from '@/utils/toast'
import { UserInfoAPI } from '@/services/user'
import { UserAPI } from '@/services/api'
import type { UserProfile } from '@/types/api'
import { getAge } from '@/utils/date'
import { useRouter } from 'vue-router'
import { useIOSKeyboard } from '@/composables/useIOSKeyboard'
import { useI18n } from 'vue-i18n'

const userStore = useUserStore()
const userInfo = computed(() => userStore.getTouristInfo())
const isEditInfo = computed(() => userStore.getIsEditInfo())
const showPicker = ref(false)
const router = useRouter()
const { t } = useI18n()

// iOS 键盘处理
const { handleInputFocus, handleInputBlur } = useIOSKeyboard()

/**
 * 仅允许数字
 */
const onlyDigits = (val: string) => (val || '').replace(/\D+/g, '')

/**
 * 数字输入适配（保持状态为 number，输入为 string）
 */
const ageFieldValue = computed({
    get: () => (form.birthYear ? String(form.birthYear) : ''),
    set: (v: string) => {
        const digits = onlyDigits(v)
        form.birthYear = digits ? Number(digits) : 0
    }
})

const weightFieldValue = computed({
    get: () => (form.userExtend.weight ? String(form.userExtend.weight) : ''),
    set: (v: string) => {
        const digits = onlyDigits(v)
        form.userExtend.weight = digits ? Number(digits) : 0
    }
})

const heightFieldValue = computed({
    get: () => (form.userExtend.height ? String(form.userExtend.height) : ''),
    set: (v: string) => {
        const digits = onlyDigits(v)
        form.userExtend.height = digits ? Number(digits) : 0
    }
})

/**
 * 计算字符串真实长度（正确处理 emoji）
 */
const getStringLength = (str: string): number => {
    return Array.from(str || '').length
}

/**
 * 限制字符串长度（正确处理 emoji）
 */
const limitString = (str: string, maxLen: number): string => {
    const chars = Array.from(str || '')
    if (chars.length <= maxLen) return str
    return chars.slice(0, maxLen).join('')
}

/**
 * 皮肤颜色
*/
const columns = ref([
    { value: 1, text: "East Asian" },
    { value: 2, text: "Southeast Asian" },
    { value: 3, text: "South Asian" },
    { value: 4, text: "Amerindian" },
    { value: 5, text: "European Caucasoid" },
    { value: 6, text: "Middle Eastern & North African" },
    { value: 7, text: "Sub-Saharan African" },
    { value: 8, text: "Oceanian" },
]);
/**
 * 表单
*/
const form = reactive<UserProfile>({
    avatar: '',
    nickname: '',
    birthYear: 0,
    sex: 0,
    raceText: '',
    userExtend: {
        height: 0,
        weight: 0,
        race: 0,
        hobby: '',
        favorite_food: '',
        character: '',
        desired_partner: ''
    },
    balance: 0,
    createdAt: 0,
    role: 0,
    noticeSwitch: 0,
    email: '',
    userId: '',
    subscribeExpired: 0
})

/**
 * 初始化表单
*/
const hydrate = () => {
    const info = userInfo.value as any
    if (!info) return
    form.avatar = info.avatar || ''
    form.nickname = info.nickname || ''
    form.birthYear = getAge(info.birthYear) || 0
    form.sex = info.sex
    form.userExtend.race = info.userExtend?.race ? info.userExtend.race : 0
    form.userExtend.height = info.userExtend?.height || 0
    form.userExtend.weight = info.userExtend?.weight || 0
    form.userExtend.hobby = info.userExtend?.hobby || ''
    form.userExtend.favorite_food = info.userExtend?.favorite_food || ''
    form.userExtend.character = info.userExtend?.character || ''
    form.userExtend.desired_partner = info.userExtend?.desired_partner || ''
    form.raceText = (columns.value.filter((item) => item.value === info.userExtend?.race))[1]?.text || ''
}

onMounted(() => {
    // userStore.setTouristInfo()
    hydrate()
})

/**
 * 上传头像
*/
const onUpload = async (e: Event) => {
    const input = e.target as HTMLInputElement
    const file = input.files?.[0]
    if (!file) return

    showLoadingToast(t('profile.uploading'))

    try {
        let uploadFile: File

        // 创建 Image 对象
        const img = new Image()
        const objectUrl = URL.createObjectURL(file)

        await new Promise<void>((resolve, reject) => {
            img.onload = () => resolve()
            img.onerror = (err) => reject(err)
            img.src = objectUrl
        })

        // canvas 绘制并导出 JPEG
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        if (!ctx) throw new Error('Canvas not supported')

        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0, img.width, img.height)

        const blob = await new Promise<Blob>((resolve) =>
            canvas.toBlob(
                (b) => {
                    if (b) resolve(b)
                },
                'image/jpeg',
                0.9
            )
        )

        uploadFile = new File([blob], file.name.replace(/\.(png|heic|heif|webp)$/i, '.jpg'), {
            type: 'image/jpeg'
        })

        // 上传
        const res = await UserAPI.uploadFile(uploadFile)
        form.avatar = res.data.fileName
        showToast(t('success.uploadSuccess'), { type: 'success' })
    } catch (err) {
        console.error('Upload failed:', err)
        showToast(t('error.uploadFailed'), { type: 'error' })
    } finally {
        closeToast()
        input.value = '' // 清空 input，方便重新上传同一张图片
    }
}



/**
 * 选择皮肤颜色
*/
const onConfirm = (value: any) => {
    form.raceText = value.selectedOptions[0].text
    form.userExtend.race = value.selectedValues[0]
    showPicker.value = false
}

/**
 * 处理输入限制（nickname 最多20个字符）
 */
const handleNicknameInput = (e: Event) => {
    const target = e.target as HTMLInputElement
    form.nickname = limitString(target.value, 20)
}

/**
 * 处理输入限制（hobby 最多100个字符）
 */
const handleHobbyInput = (e: Event) => {
    const target = e.target as HTMLTextAreaElement
    form.userExtend.hobby = limitString(target.value, 100)
}

/**
 * 处理输入限制（favorite_food 最多100个字符）
 */
const handleFavoriteFoodInput = (e: Event) => {
    const target = e.target as HTMLTextAreaElement
    form.userExtend.favorite_food = limitString(target.value, 100)
}

/**
 * 处理输入限制（character 最多100个字符）
 */
const handleCharacterInput = (e: Event) => {
    const target = e.target as HTMLTextAreaElement
    form.userExtend.character = limitString(target.value, 100)
}

/**
 * 处理输入限制（desired_partner 最多100个字符）
 */
const handleDesiredPartnerInput = (e: Event) => {
    const target = e.target as HTMLTextAreaElement
    form.userExtend.desired_partner = limitString(target.value, 100)
}

/**
 * 保存
*/
const onSave = async () => {
    showLoadingToast(t('message.saving'))
    if (!form.nickname.trim()) {
        showToast(t('profile.enterName'), { type: 'warning' })
        return
    }
    const age = getAge(form.birthYear);

    const data = {
        avatar: form.avatar,
        nickname: form.nickname,
        birthYear: age,
        height: Number(form.userExtend.height),
        weight: Number(form.userExtend.weight),
        gender: form.sex,
        hobby: form.userExtend.hobby,
        favoriteFood: form.userExtend.favorite_food,
        desiredPartner: form.userExtend.desired_partner,
        race: form.userExtend.race,
        character: form.userExtend.character,
        sex: form.sex,
    };
    try {
        await UserInfoAPI.updateUserProfile({
            ...data,
        })
        showToast(t('success.saved'), { type: 'success' })
        userStore.getUserInfo()
        userStore.setIsEditInfo(true)
        router.back()
    } catch (error) {
        console.log(error)
        showToast(t('error.saveFailed'), { type: 'error' })
    } finally {
        closeToast()
    }
}
</script>

<style scoped lang="scss">
.profile-page {
    min-height: 100vh;
    /* iOS 键盘弹出时使用真实的可视高度 */
    min-height: -webkit-fill-available;
    background: v-bind('theme.colors.background');
    /* 确保页面可以正常滚动 */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    /* 防止弹性滚动 */
    overscroll-behavior: contain;
}

.container {
    padding: 64px 20px 20px;
    /* 为底部按钮预留空间，避免输入框被遮挡 */
    // padding-bottom: 0px;
}

.section-title {
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    margin-bottom: 10px;
}

.avatar-row {
    display: flex;
}

.avatar-wrap {
    position: relative;
    width: 76px;
    height: 76px;
    border-radius: 50%;

    // overflow: hidden;
    .avatar-inner {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;
    }

    // background: #2b2e50;
}

.avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}


.upload-img {
    position: absolute;
    inset: 0;
    left: 60px;
    top: 55px;
    // opacity: 0;
    width: 20px;
    height: 20px;
    z-index: 0;
}

.upload-input {
    position: absolute;
    inset: 0;
    opacity: 0;
    z-index: 1;
}

.form {
    margin-top: 14px;
}

.field {
    margin-bottom: 14px;
}

.label {
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 500;
    color: #FFFFFF;
}

.label .req {
    background: red;
    margin-left: 4px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
}

.label .hint {
    margin-left: 8px;
    font-weight: normal;
    font-size: 9px;
    color: #5A68FF;
}

.input {
    position: relative;
    height: 40px;
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    background: v-bind('theme.colors.backgroundSecondary');
    font-weight: 500;
    font-size: 12px;
    color: v-bind('theme.colors.textPrimary') !important;
    /* 确保输入框在键盘弹出时保持可见 */
    transition: all 0.3s ease;
}

.input input {
    width: 90%;
    color: v-bind('theme.colors.textPrimary') !important;
    /* iOS 优化：防止缩放和自动填充样式冲突 */
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
}

.input .count {
    position: absolute;
    right: 10px;
    color: v-bind('theme.colors.textPrimary');
    font-size: 12px;
}

.input .sfx {
    position: absolute;
    right: 12px;
    color: v-bind('theme.colors.textPrimary');
    font-size: 12px;
}

.textarea {
    position: relative;
    border-radius: 12px;
    padding: 10px 12px 22px;
    background: v-bind('theme.colors.backgroundSecondary');
}

.textarea textarea {
    width: 100%;
    height: 86px;
    color: v-bind('theme.colors.textPrimary') !important;
    resize: none;
    font-weight: 500;
    /* iOS 优化：防止缩放 */
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
}

.textarea .count {
    position: absolute;
    right: 10px;
    bottom: 6px;
    color: v-bind('theme.colors.textPrimary') !important;
    font-size: 12px;
}

.grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.seg {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.seg-btn {
    height: 38px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    background: v-bind('theme.colors.backgroundSecondary');
    border: 1px solid transparent;
    // background: transparent;
}

.seg-btn.active {
    // background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    border: 1px solid #FFFFFF;
    font-weight: 800;
}

.footer_btn {
    display: flex;
    justify-content: center;
    padding: 10px 5px;
    // background: v-bind('theme.colors.background');
    /* iOS 键盘优化：使用 absolute 定位代替 fixed */
    /* fixed 在 iOS 键盘弹出时会有位置问题 */
    position: fixed;
    top: 25px;
    right: -20px;
    z-index: 10000000;
    height: 60px;
    /* 添加阴影以便在滚动时更清晰 */
    // box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.save-btn {
    width: calc(100% - 60px);
    height: 28px;
    border-radius: 24px;
    color: #fff;
    font-weight: 500;
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    font-size: 14px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}

.van-cell {
    width: 100% !important;
    background: transparent !important;
    // background: v-bind('theme.colors.backgroundSecondary');
    padding: 0 !important;
    border: none !important;



}

:deep(.van-field__control) {
    border: none !important;
    color: rgba(255, 255, 255, 0.5) !important;
}
</style>
